export const ApprovedFilledIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="10.7811"
        cy="10.3104"
        r="10.0077"
        fill="#56B64E"
      />
      <path
        d="M5.52637 11.5362L7.90197 13.9115L11.5023 10.3112L15.1025 6.71094"
        stroke="white"
        strokeWidth="3.39"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};